module.exports = __webpack_public_path__ + "media/images/demo_tests/grillmaster-71ee092089000360fda98c1dee1b031a.gif";